import { render, staticRenderFns } from "./form-main.vue?vue&type=template&id=c1cc30da"
import script from "./form-main.vue?vue&type=script&setup=true&lang=js"
export * from "./form-main.vue?vue&type=script&setup=true&lang=js"
import style0 from "./form-main.vue?vue&type=style&index=0&id=c1cc30da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports